import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { UntypedFormControl, ValidationErrors } from '@angular/forms';
import { AdminUserService } from 'app/modules/admin/personnel/admin-users/admin-users';
import { ClientsService } from 'app/modules/clients/clients.service';
import { Person, UserProfile } from 'app/shared/models/domain/data.model';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataFormEvent } from './data-form.model';
import { isString } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class DataFormService {

    setModel: any;
    onFormEvent$ = new EventEmitter<DataFormEvent>();

    constructor(private http: HttpClient
        , private userService: AdminUserService
        , private clientService: ClientsService
    ) {
    }

    loadForm(formUrl: string, addExtension: boolean = true): Observable<any> {
        let url: string = null;
        if (addExtension) {
            url = `/assets/forms/${formUrl}.json`;
            return this.http.get(url);
        } else {
            url = environment.apiBaseUrl + formUrl;
            return this.http.get(url).pipe(map((data: any) => data.item));
        }
    }

    getFormData(url: string, data: any): Observable<any> {
        return this.http.get<any>(environment.apiBaseUrl + url, data);
    }

    postForm(url: string, data: any): Observable<any> {
        Object.keys(data).forEach((key) => {
            if (data[key] && isString(data[key])) {
                data[key] = data[key]?.trim();
            }
        });
        if (data.id) {
            if (url === 'api/data/admin/client-certificate/create') {
                return this.http.put<any>(environment.apiBaseUrl + url + '/' + data.id, data, { responseType: 'blob' as 'json', observe: 'response' });
            }
            return this.http.put<any>(environment.apiBaseUrl + url + '/' + data.id, data);
        }
        if (url === 'api/data/admin/client-certificate/create') {
            return this.http.post<any>(environment.apiBaseUrl + url, data, { responseType: 'blob' as 'json', observe: 'response' });
        }
        return this.http.post<any>(environment.apiBaseUrl + url, data);
    }

    putForm(url: string, data: any): Observable<any> {
        Object.keys(data).forEach((key) => {
            if (data[key] && isString(data[key])) {
                data[key] = data[key]?.trim();
            }
        });
        return this.http.put(environment.apiBaseUrl + url, data);
    }

    removeForm(url: string): Observable<any> {
        return this.http.delete(environment.apiBaseUrl + url);
    }

    validateUniqueUsername(control: UntypedFormControl): Observable<ValidationErrors> {
        const model = this.setModel;
        if (control.value) {
            return this.userService.getUserByUsername(control.value)
                .pipe(map((user: UserProfile) => {
                    // if (user && user.userId > 0) {
                    if (user && user.userId > 0 && (!model.userId || (model.userId && model.userId != user.userId))) {
                        return null;
                    }
                    return { 'usernameUnique': true };
                }))
        }
        return of(null);
    }

    validateUniqueEmail(control: UntypedFormControl): Observable<ValidationErrors> {
        const model = this.setModel;
        if (control.value) {
            let email = control.value;
            email = email?.trim();
            return this.userService.getUserByEmail(email)
                .pipe(map((user: UserProfile) => {
                    if (user && user.userId > 0 && (!model.userId || (model.userId && model.userId != user.userId))) {
                        return null;
                    }
                    return { 'emailUnique': true };
                }))
        }
        return of(null);
    }

    validateContactUniqueEmail(control: UntypedFormControl): Observable<ValidationErrors> {
        const model = this.setModel;
        if (control.value) {
            let email = control.value;
            email = email?.trim();
            return this.clientService.getPersonByEmail(email)
                .pipe(map((user: Person) => {
                    if (user && user.personId > 0 && (!model.personId || (model.personId && model.personId != user.personId))) {
                        return null;
                    }
                    return { 'contactEmailUnique': true };
                }))
        }
        return of(null);
    }
}
